import { useContext, useEffect } from "react";
import { MessageContext, MessageOutletProps } from ".";
import {
	MessageBar,
	MessageBarActions,
	MessageBarBody,
	MessageBarGroup,
	Button,
} from "@fluentui/react-components";
import { DismissRegular } from "@fluentui/react-icons";

const MessageOutlet = ({ namespace, style }: MessageOutletProps) => {
	const { messages, hide } = useContext(MessageContext);

	useEffect(() => {
		return () => {
			messages.get(namespace)?.forEach((x) => {
				hide(namespace, x.id);
			});
		};
	}, []);

	return (
		<MessageBarGroup style={style}>
			{messages.get(namespace)?.map((message) => (
				<MessageBar key={message.id} intent={message.intent}>
					<MessageBarBody style={message.bodyStyle}>
						{message.text}
					</MessageBarBody>
					<MessageBarActions
						containerAction={
							<Button
								appearance="transparent"
								icon={<DismissRegular />}
								onClick={() => hide(namespace, message.id)}
							/>
						}
					>
						{message.action && (
							<Button onClick={() => message.action?.onActionClick()}>
								{message.action.name}
							</Button>
						)}
					</MessageBarActions>
				</MessageBar>
			)) ?? []}
		</MessageBarGroup>
	);
};

export default MessageOutlet;
